import { useState, useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { Button } from './ui/button';
import { X, Camera, CameraOff } from 'lucide-react';

const QrScannerModal = ({ open, onClose, onScan }) => {
  const [error, setError] = useState('');
  const [scanning, setScanning] = useState(false);
  const scannerRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    let html5Qr = null;

    const startScanner = async () => {
      try {
        setError('');
        setScanning(true);
        html5Qr = new Html5Qrcode('qr-reader');
        scannerRef.current = html5Qr;

        await html5Qr.start(
          { facingMode: 'environment' },
          { fps: 10, qrbox: { width: 250, height: 250 }, aspectRatio: 1 },
          (decodedText) => {
            html5Qr.stop().catch(() => {});
            scannerRef.current = null;
            setScanning(false);
            onScan(decodedText);
          },
          () => {}
        );
      } catch (err) {
        setScanning(false);
        setError("Impossible d'accéder à la caméra. Vérifiez les permissions.");
      }
    };

    const timer = setTimeout(startScanner, 300);

    return () => {
      clearTimeout(timer);
      if (scannerRef.current) {
        scannerRef.current.stop().catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [open, onScan]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" data-testid="qr-scanner-modal">
      <div className="bg-[#0E1527] rounded-2xl w-full max-w-md overflow-hidden border border-[rgb(var(--lm-gold)/0.3)]">
        <div className="flex items-center justify-between px-4 py-3 border-b border-[rgb(var(--lm-border)/0.5)]">
          <div className="flex items-center gap-2">
            <Camera size={18} className="text-[rgb(var(--lm-gold))]" />
            <h3 className="text-sm font-medium text-[rgb(var(--lm-text))]">Scanner un Bon Cadeau</h3>
          </div>
          <button onClick={onClose} className="text-[rgb(var(--lm-text-muted))] hover:text-[rgb(var(--lm-text))]" data-testid="close-scanner">
            <X size={20} />
          </button>
        </div>

        <div className="p-4">
          <div id="qr-reader" ref={containerRef} className="rounded-xl overflow-hidden bg-black min-h-[280px]" />
          {error && (
            <div className="mt-3 flex items-center gap-2 text-red-400 text-xs bg-red-400/10 p-3 rounded-lg" data-testid="scanner-error">
              <CameraOff size={16} />
              <span>{error}</span>
            </div>
          )}
          <p className="text-center text-[10px] text-[rgb(var(--lm-text-muted))] mt-3">
            Placez le QR code du bon cadeau devant la caméra
          </p>
        </div>
      </div>
    </div>
  );
};

export default QrScannerModal;
